import * as methods from 'api/core/actions';
import type { ProjectTemplate } from 'redux/modules/projectTemplates';

export async function getProjectTemplates(): Promise<Array<ProjectTemplate>> {
  return methods.Get('project_templates');
}

type ProjectTemplatePayload = Partial<Omit<ProjectTemplate, 'id' | 'updated_at'>> & {
  name: string;
};

export async function createProjectTemplate(
  template: ProjectTemplatePayload
): Promise<ProjectTemplate> {
  return methods.Post('project_templates', { project_template: template });
}

export async function updateProjectTemplate(
  id: number,
  template: Partial<Omit<ProjectTemplate, 'id' | 'updated_at'>>
): Promise<ProjectTemplate> {
  return methods.Put(`project_templates/${id}`, { project_template: template });
}

export async function deleteProjectTemplate(id: number): Promise<void> {
  return methods.Delete(`project_templates/${id}`);
}
